import {breakpoint} from './breakpoint'

const itemAmountToggle = (() => {
    const init = () => {
        const togglers = document.querySelectorAll(`[data-amount-toggle]`)

        togglers.forEach(toggler => initActions(toggler))
    };

    const onClickToggle = (e, component) => {
        e.preventDefault();

        e.target.classList.toggle('toggled')
        toggleElements(component.items, component.amount);
    }

    const toggleElements = (items, amount) => {
        items.forEach((item, index) => {
            if(index + 1 > amount) {
                item.classList.toggle('hide');
            }
        })
    }

    const initActions = (el) => {
        const isMobile = breakpoint.medium('down');
        const amountMobile = el.getAttribute('data-toggle-mobile');
        const amountDesktop = el.getAttribute('data-toggle-desktop');
        const amount = isMobile ? amountMobile : amountDesktop;

        const items = el.querySelectorAll('[data-toggle-item]');
        const toggler = el.querySelector('[data-toggle]');

        if( breakpoint.large('up') && !amountDesktop) return;
        if( isMobile && !amountMobile) return;
        if( amount >= items.length) return;

        toggleElements(items, amount);
        toggler.classList.remove('hide');
        toggler.addEventListener("click", (e) => onClickToggle(e, {items, amount}) );
    };

    return {
        init: init
    };
})();

export {itemAmountToggle}
